// app/javascript/packs/application.js

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import Turbolinks from "turbolinks";
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers"
import { Tooltip, Popover } from "bootstrap";

import "channels";
import "bootstrap";
import "../stylesheets/application";

// --- Start Rails JS features ---
Rails.start();
ActiveStorage.start();
Turbolinks.start();
const images = require.context('../images', true);
const application = Application.start();
const context = require.context("controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

// --- Initialize Bootstrap JS plugins after Turbolinks load ---
document.addEventListener("turbolinks:load", () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(el => new Tooltip(el));

  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(el => new Popover(el));
});
